import { render, staticRenderFns } from "./InjuryTypeDelete.vue?vue&type=template&id=8b6426f4&"
import script from "./InjuryTypeDelete.vue?vue&type=script&lang=js&"
export * from "./InjuryTypeDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports